import { render, staticRenderFns } from "./ItemSubGroup.vue?vue&type=template&id=20364963&"
import script from "./ItemSubGroup.vue?vue&type=script&lang=ts&"
export * from "./ItemSubGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports